import { render, staticRenderFns } from "./ReservationDialog.vue?vue&type=template&id=51f81c58"
import script from "./ReservationDialog.vue?vue&type=script&lang=js"
export * from "./ReservationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports